import { useState } from "react";
import { FaLock, FaLockOpen } from "react-icons/fa";
import { EtapaGerenciarEmplacamentosEnum } from "../../enums/EtapaGerenciarEmplacamentos.enum";
import { StatusEtapaGerenciarEmplacamentosEnum } from "../../enums/StatusEtapaGerenciarEmplacamentos.enum";
import { HttpResponse } from "_services/api/HttpResponse";
import { IListarEmplacamentosPR } from "../../Interfaces/IListarEmplacamentosPR";
import { ModalConfirmarBloqueio } from "../ModalConfirmarBloqueio";
import { ModalErroBloqueio } from "../ModalErroBloqueio";

interface HandleStatusBloqueioProps {
  etapa: EtapaGerenciarEmplacamentosEnum;
  status: StatusEtapaGerenciarEmplacamentosEnum;
  statusBloqueio: string | null;
  idVeiculo: number;
  idProcesso: number;
  bloquearVeiculo: (id: number) => Promise<HttpResponse>;
  buscarUltimoBloqueioVeiculo: (idVeiculo: number) => Promise<HttpResponse>;
  abrirProcessoBloqueio: (idVeiculo: number) => Promise<void>;
  dados: IListarEmplacamentosPR[];
  setDados: (dados: IListarEmplacamentosPR[]) => void;
}

export function HandleStatusBloqueio({
  etapa,
  status,
  statusBloqueio,
  idVeiculo,
  idProcesso,
  bloquearVeiculo,
  buscarUltimoBloqueioVeiculo,
  abrirProcessoBloqueio,
  dados,
  setDados,
}: HandleStatusBloqueioProps) {
  const [showModal, setShowModal] = useState(false);
  const [showModalErro, setShowModalErro] = useState(false);
  const [descricaoErro, setDescricaoErro] = useState("");
  const [loading, setLoading] = useState(false);

  const etapasPosteriores = [
    EtapaGerenciarEmplacamentosEnum.PAGAR_IPVA,
    EtapaGerenciarEmplacamentosEnum.FINALIZAR_PROCESSO,
  ];

  const placaSolicitada =
    etapasPosteriores.includes(etapa) ||
    (etapa === EtapaGerenciarEmplacamentosEnum.SOLICITAR_PLACA &&
      status === StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO);

  const atualizarBloqueio = (novoStatus: string) => {
    dados.forEach((p) => {
      if (p.id === idProcesso) {
        p.statusBloqueio = novoStatus;
      }
    });
    setDados([...dados]);
  };

  const handleBloqueio = async () => {
    setShowModal(false);
    setShowModalErro(false);
    setLoading(true);

    const { hasErro } = await bloquearVeiculo(idProcesso);
    if (hasErro) {
      atualizarBloqueio("erro");
    }
    setLoading(false);
  };

  const handleClickIcone = async () => {
    setLoading(true);
    const { hasErro, data } = await buscarUltimoBloqueioVeiculo(idVeiculo);
    setLoading(false);

    if (hasErro || !data) {
      setShowModal(true);
      return;
    }

    setDescricaoErro(data.observacaoBloqueio ?? "Erro ao bloquear veículo");
    setShowModalErro(true);
  };

  if (!placaSolicitada || loading) {
    return (
      <FaLock
        style={{ color: "#999999" }}
        title="Disponível após solicitar a placa"
      />
    );
  }

  if (statusBloqueio === "bloqueado") {
    return (
      <FaLock
        style={{ color: "#dc3545", cursor: "pointer" }}
        title="Veículo bloqueado - clique para ver o processo"
        onClick={() => abrirProcessoBloqueio(idVeiculo)}
      />
    );
  }

  return (
    <>
      <FaLockOpen
        style={{ color: "#28a745", cursor: "pointer" }}
        title="Bloquear veículo"
        onClick={handleClickIcone}
      />
      <ModalConfirmarBloqueio
        show={showModal}
        handleClose={() => setShowModal(false)}
        onConfirmar={handleBloqueio}
      />
      <ModalErroBloqueio
        show={showModalErro}
        handleClose={() => setShowModalErro(false)}
        onReprocessar={handleBloqueio}
        descricaoErro={descricaoErro}
      />
    </>
  );
}
